import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import type { SelectFilterItem } from '@/components/select-filter/types'

import { CASE_ARCHIVE_STATUS_MAP } from '@/lib/queries/business/constants'
import { getCaseFiltersQuery } from '@/lib/queries/business/v2/case/filters/queries'

const useCaseAnalysisPage = () => {
  const { data: dataFiltersImmigration } = useQuery(
    getCaseFiltersQuery({
      archiveStatus: CASE_ARCHIVE_STATUS_MAP.all,
      isEoir: false,
    })
  )

  const { data: dataFiltersEoir } = useQuery(
    getCaseFiltersQuery({
      archiveStatus: CASE_ARCHIVE_STATUS_MAP.all,
      isEoir: true,
    })
  )

  const assignees = useMemo<SelectFilterItem[]>(() => {
    const merged = [...(dataFiltersImmigration?.assignees ?? []), ...(dataFiltersEoir?.assignees ?? [])]
    const unique = merged.filter(
      (item, index, self) => index === self.findIndex((t) => t.filterValue === item.filterValue)
    )
    return unique.map((x) => ({
      filterName: x.filterName,
      filterValue: x.filterValue.toString(),
      count: x.count,
    }))
  }, [dataFiltersImmigration, dataFiltersEoir])

  const tags = useMemo<SelectFilterItem[]>(() => {
    const merged = [...(dataFiltersImmigration?.tags ?? []), ...(dataFiltersEoir?.tags ?? [])]
    const unique = merged.filter(
      (item, index, self) => index === self.findIndex((t) => t.filterValue === item.filterValue)
    )
    return unique.map((x) => ({
      filterName: x.filterName,
      filterValue: x.filterValue.toString(),
      count: x.count,
    }))
  }, [dataFiltersImmigration, dataFiltersEoir])

  return {
    assignees,
    tags,
  }
}

export default useCaseAnalysisPage
